export const SET_LIKED = 'Client/SET_LIKED';
export const SET_PROFILE = 'Client/SET_PROFILE';
export const SET_CONNECTED_WALLET = 'Client/SET_CONNECTED_WALLET';
export const SAVE_CONNECTED_WALLET = 'Client/SAVE_CONNECTED_WALLET';
export const GET_OWNED_NFTS = 'Client/GET_OWNED_NFTS';